<div class="detail-fill__popup__container">
  <div class="detail-fill__popup__body">
    <p-tabView
      #tabView
      styleClass="bfx-tabview"
      (onClose)="onTabClose($event)"
      (onChange)="handleTabChange($event)"
    >
      <p-tabPanel
        *ngFor="let fillPair of fillOrdersModel.groups; let i = index"
        [selected]="i == 0"
        [closable]="true"
        header="{{fillPair.pairName}}"
        styleClass="detail-fill-tab-panel"
      >
        <bfx-detail-fill-grid
          #gridTabs
          [fillOrderGroup]="fillPair"
          [columnsConfig]="columnsConfiguration"
          (selectedOrdersChange)="selectedOrdersChange($event)"
          (gridLayoutChange)="gridLayoutChange($event)"
          styleClass="detail-fill-tab-panel"
        >
        </bfx-detail-fill-grid>
      </p-tabPanel>
    </p-tabView>
  </div>
  <div class="detail-fill__popup__footer" fxLayout="row" fxLayoutAlign="start stretch">
    <div fxFlex fxLayout="row" class="detail-fill_action-panel">
      <bfx-autoComplete
        #posBoookAuto
        [checkDirtyBlur]="true"
        [(ngModel)]="curPosBook"
        [allowEmptySelection]="true"
        [emptyIsInactive]="true"
        [useAlternateBlur]="true"
        [alternateConfig]="control.positionBookAutocompleteConfig"
        (onFocus)="onPosBookFocus($event)"
        (completeMethod)="searchPosBooks($event)"
        (onSelect)="onSelectPosBook($event)"
        [suggestions]="suggestionsPosBooks"
        appendTo="body"
        nativeDesktopDropdown="generic"
        field="label"
        dataKey="value"
        [dropdown]="true"
        delay="5"
        label="Position Book"
        [minLength]="0"
        size="sm"
        [disabled]="positionBookSelectionDisabled"
      >
      </bfx-autoComplete>
    </div>
    <div
      fxFlex
      class="bfx-detail-fill-vwap"
      [class.buy]="intentType == OI.BUY"
      [class.sell]="intentType == OI.SELL"
    >
      <span [innerHtml]="vwap"></span>
    </div>
    <div fxFlex fxLayout="row" fxLayoutAlign="end center" class="detail-fill_button-panel">
      <p-menu
        #menu
        styleClass="popup-notification__menu"
        nativeDesktopMenu="detailFill"
        [popup]="true"
        appendTo="body"
        placement="top left"
        [model]="fillOrdersModel.menuItems"
      ></p-menu>
      <button [disabled]="!showClose" class="bfx-button-inverse-dark" (click)="close()">
        Close
      </button>
      <button
        [disabled]="!fillOrdersModel.showReactivate"
        class="bfx-button-secondary"
        (click)="reactivate()"
      >
        Reactivate
      </button>
      <button
        [disabled]="!fillOrdersModel.showFill"
        *ngIf="fillOrdersModel && fillOrdersModel.menuItems.length <= 1"
        class="bfx-button-primary"
        (click)="fillSelected()"
      >
        Fill
      </button>
      <p-splitButton
        label="Fill"
        [disabled]="!fillOrdersModel.showFill"
        *ngIf="fillOrdersModel && fillOrdersModel.menuItems.length > 1"
        (onClick)="fillSelected()"
        class="bfx-button-primary-bold-unsized bfx-button-sm"
        [model]="fillOrdersModel.menuItems"
        menuStyleClass="bfx-dashboard-menu"
      >
      </p-splitButton>
    </div>
  </div>
</div>
